import { render, staticRenderFns } from "./ProfileEcRisk.vue?vue&type=template&id=57fbaf80&scoped=true"
import script from "./ProfileEcRisk.vue?vue&type=script&lang=js"
export * from "./ProfileEcRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fbaf80",
  null
  
)

export default component.exports